import { memo } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import CommunitySetupComponent from './CommunitySetupComponent';

import { getBuildingsForFilter } from '../../Building/actionCreators';
import { onModalClose, showRenderPropsModal } from '../../Modal/actions';
import { getAllPmcReducedData } from '../../PMC/actionCreators';
import { getCommunityList, updateCommunity } from '../actions';

import { arePropsEqual } from '../../../utils';

import * as buildingSelectors from '../../Building/selectors';
import * as pmcSelectors from '../../PMC/selectors';
import * as commonSelectors from '../../Shared/selectors';
import * as communitySelectors from '../selectors';

const LIST_KEY = 'community';

const CommunitySetupContainer = (props) => {
  const { updateCommunity, getItems, onGetCommunityList, listParams } = props;

  const onExport = (paginationParams) => {
    const queryParams = { ...listParams, ...paginationParams };
    return onGetCommunityList(queryParams);
  };

  const onCommunityUpdate = async (community, newValues) => {
    const { id, buildings, ...rest } = community;
    const data = {
      ...rest,
      buildings: buildings?.map(({ id }) => id),
      ...newValues,
    };
    const res = await updateCommunity(id, data);
    getItems(listParams);
    return res;
  };

  return (
    <CommunitySetupComponent
      {...props}
      onExport={onExport}
      onCommunityUpdate={onCommunityUpdate}
    />
  );
};

CommunitySetupContainer.propTypes = {
  updateCommunity: PropTypes.func.isRequired,
  getItems: PropTypes.func.isRequired,
  onGetCommunityList: PropTypes.func.isRequired,
  listParams: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = (state) => {
  const items = communitySelectors.getCommunityList(state);
  const listParams = commonSelectors.getListParams(state, LIST_KEY);
  const pmcs = pmcSelectors.getPmcsList(state);
  const buildings = buildingSelectors.getBuildingsList(state);

  return {
    listKey: LIST_KEY,
    listParams,
    items,
    pmcs,
    buildings,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onLoad: () => {
    getAllPmcReducedData(dispatch);
    getBuildingsForFilter(dispatch);
    getCommunityList(
      dispatch,
      { disable_pagination: true, enabled: true },
      false,
      true,
    );
  },
  getItems: (queryParams) => getCommunityList(dispatch, queryParams),
  onGetCommunityList: (queryParams) =>
    getCommunityList(dispatch, queryParams, true),
  updateCommunity: (id, data) => updateCommunity(dispatch, id, data),
  openModal: (props) => showRenderPropsModal(dispatch, props),
  closeModal: () => onModalClose(dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(memo(CommunitySetupContainer, arePropsEqual));
